export const CLIENT_INACTIVE_SESSION = 10 * 60 * 1000;
export const MOBILE_BOTTOM_NAV_API_SUCCESS = 'MOBILE_BOTTOM_NAV_API_SUCCESS';
export const MOBILE_BOTTOM_NAV_API_ERROR = 'MOBILE_BOTTOM_NAV_API_ERROR';
export const MOBILE_TOP_NAV_API_SUCCESS = 'MOBILE_TOP_NAV_API_SUCCESS';
export const MOBILE_TOP_NAV_API_ERROR = 'MOBILE_TOP_NAV_API_ERROR';
export const SET_JIO_BANNER_ADS = 'SET_JIO_BANNER_ADS';
export const jioBannerAdsListingURLS = {
  Stg: 'https://mercury-stg.jio.com/delivery/mapi.php',
  Prod: 'https://mercury.jio.com/delivery/mapi.php'
};

export const jioBannerAdsListingAdspotId = {
  Prod: '6yazm3k1',
  Stg: 'kuna3rfc'
};

// requestType for signup API

export const requestType = {
  SENDOTP: 'SENDOTP',
  AUTHUSER: 'AUTHUSER'
};

export const STREET_STORE = 'street';
export const LUXE_STORE = 'luxe';
export const AJIO_STORE = 'ajio';
export const FLEEK_STORE = 'ajiogram';
export const FLEEK_VIDEO_RADIUS = 4;
